import styled from 'styled-components';

const GradientDivider = styled.div`
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #fafafa 0%, #d7d7d7 50%, #fafafa);
  &:not(.flat) {
    margin: 15px 0;
  }

  &.thin {
    margin: 10px 0;
  }

  &.left-anchor {
    background: linear-gradient(to right, #d7d7d7 0%, #fafafa);
  }

  &.right-anchor {
    background: linear-gradient(to right, #fafafa 0%, #d7d7d7);
  }
`;

export default GradientDivider;
